import React from 'react';
import dayjs from 'dayjs';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SharedProgrammeWithUserEnrolledPopupMenu from './shared_programme_with_user_enrolled_popup_menu';
import enrolled_programme_card_background from '../../assets/images/enrolled_programme_card_background.png';
import { END_USER_SHARED_PROGRAMMES_ROUTE } from '../../services/routes';
import {
  programmeStartCalendarDay,
  programmeTotalDays,
} from '../../services/my_day';
import {
  useDeleteContentEntryMutation,
  useDeleteMealMutation,
  useDeleteNoteMutation,
  useGetSharedProgrammeQuery,
  useUpdateDbPlannerWeekMutation,
  useUpdateUserProgrammeEnrollmentMutation,
} from '../../app/smorgAppSyncGraphQLApi';
import { userCountryCode } from '../../services/users';
import {
  calendarDayFromJSDate,
  formatDayAndMonthInLocale,
} from '../../services/dates';
import {
  useCurrentProgrammeEnrollmentQuery,
  useGetUserProfileQuery,
  useLazyGetOrCreateDbPlannerWeekByStartDateQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { showGlobalSnackbar } from '../../features/global_snackbar/global_snackbar_slice';
import { clearPlanner } from '../../operations/planner_operations';
import { SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const ProgrammeProgressNotYetStarted = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: userProfile } = useGetUserProfileQuery();

  const { data: currentProgrammeEnrollment } =
    useCurrentProgrammeEnrollmentQuery();

  const countryCode = userCountryCode(userProfile);

  const { sharedProgrammeID } = currentProgrammeEnrollment || {};

  const { data: sharedProgramme } = useGetSharedProgrammeQuery(
    sharedProgrammeID,
    {
      skip: !sharedProgrammeID,
      refetchOnMountOrArgChange: SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS,
    },
  );

  const [updateUserProgrammeEnrollment] =
    useUpdateUserProgrammeEnrollmentMutation();

  const [deleteMeal] = useDeleteMealMutation();

  const [deleteNote] = useDeleteNoteMutation();

  const [deleteContentEntry] = useDeleteContentEntryMutation();

  const [updateDbPlannerWeek] = useUpdateDbPlannerWeekMutation();

  const [lazyGetOrCreateDbPlannerWeekByStartDate] =
    useLazyGetOrCreateDbPlannerWeekByStartDateQuery();
  const sharedProgrammeTitle = sharedProgramme?.title;

  const programmeStartDate = programmeStartCalendarDay(
    currentProgrammeEnrollment,
  );

  const [searchParams] = useSearchParams();

  const todayOverride = searchParams.get('asOf');

  const today = todayOverride || calendarDayFromJSDate(new Date());

  const programmeLength = sharedProgramme
    ? programmeTotalDays(sharedProgramme)
    : 0;

  const enrollmentEffectiveEndDate = dayjs(programmeStartDate)
    .add(programmeLength, 'day')
    .format('YYYY-MM-DD');

  /** TODO duplicate code in programme_progress */
  const onStopProgram = async (shouldClearPlanner) => {
    console.log('Before navigate');
    navigate(END_USER_SHARED_PROGRAMMES_ROUTE);
    console.log(
      'Before endProgrammeEnrollmentAction, shouldClearPlanner:',
      shouldClearPlanner,
    );
    const programmeEnrollmentEnding = {
      ...currentProgrammeEnrollment,
      endedAt: new Date().toISOString(),
    };
    await updateUserProgrammeEnrollment(programmeEnrollmentEnding);
    if (shouldClearPlanner) {
      const clearFromDate = today;
      console.log(
        `Clearing planner from ${clearFromDate} to ${enrollmentEffectiveEndDate}`,
      );
      clearPlanner(
        clearFromDate,
        enrollmentEffectiveEndDate,
        lazyGetOrCreateDbPlannerWeekByStartDate,
        dispatch,
        deleteMeal,
        deleteNote,
        deleteContentEntry,
        updateDbPlannerWeek,
      );
    }
    console.log('Before showGlobalSnackbar');
    dispatch(
      showGlobalSnackbar({
        notificationText: 'You have stopped the program',
      }),
    );
  };

  return (
    <div className="alternatives-page">
      <div className="topNavBarMobile">
        <div style={{ paddingLeft: '23px', margin: 'auto 0' }}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href="#"
            style={{ textDecoration: 'none' }}
            onClick={(ev) => {
              ev.preventDefault();
              navigate(-1);
            }}>
            <FontAwesomeIcon icon="chevron-left" />
            Back
          </a>
        </div>
        <div style={{ margin: 'auto', marginRight: 10 }}>
          <SharedProgrammeWithUserEnrolledPopupMenu
            onStopProgram={onStopProgram}
          />
        </div>
      </div>
      <Grid container>
        <Grid item xs={12} style={{ textAlign: 'left' }}>
          <h2
            style={{
              fontSize: '24px',
              color: 'var(--app-primary-font-color)',
              margin: '23px 23px 10px',
            }}>
            {sharedProgrammeTitle}
          </h2>
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'left' }}>
          <h3
            style={{
              fontSize: '16px',
              color: 'var(--app-primary-font-color)',
              fontWeight: 'normal',
              margin: '10px 23px',
            }}>
            Due to start{' '}
            {formatDayAndMonthInLocale(programmeStartDate, countryCode)}
          </h3>
        </Grid>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <div
        style={{
          width: 316,
          height: 194,
          backgroundColor: 'white',
          color: 'black',
          margin: '10px 23px',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
          borderRadius: '30px',
          overflow: 'hidden',
        }}>
        <div style={{ display: 'flex' }}>
          <div style={{ padding: 16, width: 166 }}>
            <div
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                marginBottom: 24,
              }}>
              Your plan is starting soon!
            </div>
            <div>
              {formatDayAndMonthInLocale(programmeStartDate, countryCode)}
            </div>
          </div>
          <div
            style={{
              width: 150,
              height: 194,
              backgroundImage: `url("${enrolled_programme_card_background}")`,
              backgroundSize: 'cover',
            }}>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgrammeProgressNotYetStarted;
